import React, { useEffect, useState } from 'react';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Dashboard from '../../assets/icons/dashboard.svg';
import DashboardActive from '../../assets/icons/dashboard-active.svg';
import Catalog from '../../assets/icons/catalog-analyzer.svg';
import CatalogActive from '../../assets/icons/catalog-analyzer-active.svg';
import Inventory from '../../assets/icons/inventory.svg';
import InventoryActive from '../../assets/icons/inventory-active.svg';
import Purchasing from '../../assets/icons/purchasing.svg';
import PurchasingActive from '../../assets/icons/purchasing-active.svg';
import Logistics from '../../assets/icons/logistics.svg';
import LogisticsActive from '../../assets/icons/logistics-active.svg';
import ShipmentInvoice from '../../assets/icons/shipment-invoice.svg';
import ShipmentInvoiceActive from '../../assets/icons/shipment-invoice-active.svg';
import BillingIcon from '../../assets/icons/purchasing.svg';
import BillingIconActive from '../../assets/icons/purchasing-active.svg';
import Settings from '../../assets/icons/settings.svg';
import SettingsActive from '../../assets/icons/settings-active.svg';
import { PERMISSION_MAP } from '../../constants/routes';

import { SidebarContainer } from './style';
import 'react-pro-sidebar/dist/css/styles.css';

const Sidebar = ({ handleSetTab, collapsed, selectedTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [locationPathname, setLocationPathname] = useState(location.pathname);

  const { currentUser: user, currentActiveSubscription } = useSelector((state) => state?.auth || {});

  useEffect(() => {
    const activeMenu = menuData.find(menu => {
      if (menu.subMenu) {
        return menu.subMenu.some(item => item.path === location.pathname);
      }
      return menu.path === location.pathname;
    });
    if (activeMenu && activeMenu.subMenu) {
      setOpenSubMenu(activeMenu.label);
    } else {
      setOpenSubMenu(null);
    }

    setLocationPathname(location.pathname);
  }, [location.pathname, menuData]);

  const userMenu = [
    // {
    //   label: "Dashboard",
    //   icon: locationPathname === "/sales" ? <img src={DashboardActive} /> : <img src={Dashboard} />,
    //   path: "/sales",
    // },
    // {
    //   label: "Catalog Analyzer",
    //   icon: locationPathname === "/catalog-jobs" ? <img src={CatalogActive} /> : <img src={Catalog} />,
    //   path: "/catalog-jobs",
    // },
    // {
    //   label: "Employees",
    //   icon: locationPathname === "/employees" ? <img src={SettingsActive} /> : <img src={Settings} />,
    //   path: "/employees",
    // },
    {
      label: 'Inventory',
      permission: ['inventory'],
      icon: ['/inventory/sku', '/inventory/products', '/inventory/vendor'].includes(locationPathname) || (openSubMenu === 'Inventory') ? <img src={InventoryActive} /> : <img src={Inventory} />,
      subMenu: [
        { label: 'SKU', path: '/inventory/sku', permission: ['inventory'] },
        { label: 'Products', path: '/inventory/products', permission: ['inventory'] },
        { label: 'Vendor Items', path: '/inventory/vendor', permission: ['inventory'] }
      ]
    },
    {
      label: 'Purchasing',
      permission: ['purchasing'],
      icon: ['/vendors', '/po-history'].includes(locationPathname) || (openSubMenu === 'Purchasing') ? <img src={PurchasingActive} /> : <img src={Purchasing} />,
      subMenu: [
        { label: 'Vendor CRM', path: '/vendors', permission: ['purchasing'] },
        { label: 'Purchase Orders', path: '/po-history', permission: ['purchasing'] }
      ]
    },
    {
      label: 'Sourcing',
      permission: ['catalog'],
      icon: ['/sourcing', '/database'].includes(locationPathname) || (openSubMenu === 'Sourcing') ? <img src={PurchasingActive} /> : <img src={Purchasing} />,
      subMenu: [
        { label: 'Supplier Matching', path: '/sourcing', permission: ['catalog'] },
        { label: 'Database', path: '/database', permission: ['catalog'] }
      ]
    },
    {
      label: 'Logistics',
      permission: ['logistics'],
      icon: locationPathname.includes('/work-order') || (openSubMenu === 'Logistics') ? <img src={LogisticsActive} /> : <img src={Logistics} />,
      subMenu: [
        { label: 'Work Orders', path: '/work-orders', permission: ['logistics'] }
      ]
    },
    {
      label: 'File History',
      icon: locationPathname === '/file-upload-history' ? <img src={ShipmentInvoiceActive} /> : <img src={ShipmentInvoice} />,
      path: '/file-upload-history',
      permission: ['fileHistory']
    },
    // {
    //   label: "Shipment Invoice",
    //   icon: locationPathname === "/user-invoices" ? <img src={ShipmentInvoiceActive} /> : <img src={ShipmentInvoice} />,
    //   path: "/user-invoices",
    // },
    {
      label: 'Settings',
      icon: ['/account', '/users', '/billing'].includes(locationPathname) || (openSubMenu === 'Settings') ? <img src={SettingsActive} /> : <img src={Settings} />,
      permission: ['settings'],
      subMenu: [
        {
          label: 'Account',
          path: '/account',
          permission: ['settings']
        },
        {
          label: 'Employee',
          path: '/employees',
          permission: ['settings']
        },
        {
          label: 'Billing',
          path: '/billing',
          permission: ['settings']
        }
      ]
    }
  ];

  const warehouseMenu = [
    {
      label: 'Dashboard',
      icon: locationPathname === '/dashboard' ? <img src={DashboardActive} /> : <img src={Dashboard} />,
      path: '/dashboard',
      permission: ['dashboard']
    },
    {
      label: 'Logistics',
      icon: ['/po-warehouse', '/warehouse-work-orders', '/warehouse-location', '/location-names'].includes(locationPathname) || (openSubMenu === 'Logistics') ? <img src={LogisticsActive} /> : <img src={Logistics} />,
      permission: ['purchasing', 'logistics', 'location'],
      subMenu: [
        { label: 'Purchase Orders', path: '/po-warehouse', permission: ['purchasing'] },
        { label: 'Work Orders', path: '/warehouse-work-orders', permission: ['logistics'] },
        { label: 'Locations', path: '/warehouse-location', permission: ['location'] }
      ]
    },
    {
      label: 'File History',
      icon: locationPathname === '/file-upload-history' ? <img src={ShipmentInvoiceActive} /> : <img src={ShipmentInvoice} />,
      path: '/file-upload-history',
      permission: ['fileHistory']
    },
    {
      label: 'Clients',
      icon: locationPathname === '/clients' ? <img src={SettingsActive} /> : <img src={Settings} />,
      path: '/clients',
      permission: ['clients']
    },
    // {
    //   label: "Shipment Invoice",
    //   icon: locationPathname === "/user-invoices" ? <img src={ShipmentInvoiceActive} /> : <img src={ShipmentInvoice} />,
    //   path: "/user-invoices",
    // },
    {
      label: 'Settings',
      icon: ['/account', '/users'].includes(locationPathname) || (openSubMenu === 'Settings') ? <img src={SettingsActive} /> : <img src={Settings} />,
      permission: ['settings'],
      subMenu: [
        {
          label: 'Account',
          path: '/account',
          permission: ['settings']
        },
        {
          label: 'Employee',
          path: '/employees',
          permission: ['settings']
        }
        // {
        //   label: "Payment",
        //   path: "/payments",
        // },
      ]
    }
  ];

  const sellerPlusWarehouseMenu = [
    {
      label: 'Dashboard',
      icon: locationPathname === '/dashboard' ? <img src={DashboardActive} /> : <img src={Dashboard} />,
      path: '/dashboard',
      permission: ['dashboard']
    },
    // {
    //   label: "Employees",
    //   icon: locationPathname === "/employees" ? <img src={SettingsActive} /> : <img src={Settings} />,
    //   path: "/employees",
    // },
    {
      label: 'Inventory',
      icon: ['/inventory/sku', '/inventory/products', '/inventory/vendor'].includes(locationPathname) || (openSubMenu === 'Inventory') ? <img src={InventoryActive} /> : <img src={Inventory} />,
      permission: ['inventory'],
      subMenu: [
        { label: 'SKU', path: '/inventory/sku', permission: ['inventory'] },
        { label: 'Products', path: '/inventory/products', permission: ['inventory'] },
        { label: 'Vendor Items', path: '/inventory/vendor', permission: ['inventory'] }
      ]
    },
    {
      label: 'Purchasing',
      icon: ['/vendors', '/po-history'].includes(locationPathname) || (openSubMenu === 'Purchasing') ? <img src={PurchasingActive} /> : <img src={Purchasing} />,
      permission: ['purchasing'],
      subMenu: [
        { label: 'Vendor CRM', path: '/vendors', permission: ['purchasing'] },
        { label: 'Purchase Orders', path: '/po-history', permission: ['purchasing'] }
      ]
    },
    {
      label: 'Sourcing',
      permission: ['catalog'],
      icon: ['/sourcing', '/database'].includes(locationPathname) || (openSubMenu === 'Sourcing') ? <img src={PurchasingActive} /> : <img src={Purchasing} />,
      subMenu: [
        { label: 'Supplier Matching', path: '/sourcing', permission: ['catalog'] },
        { label: 'Database', path: '/database', permission: ['catalog'] }
      ]
    },
    {
      label: 'Logistics',
      icon: ['/po-warehouse', '/warehouse-work-orders', '/warehouse-location', '/location-names'].includes(locationPathname) || (openSubMenu === 'Logistics') ? <img src={LogisticsActive} /> : <img src={Logistics} />,
      permission: ['location'],
      subMenu: [
        { label: 'Work Orders', path: '/work-orders', permission: ['logistics'] },
        { label: 'Locations', path: '/warehouse-location', permission: ['location'] }
      ]
    },
    {
      label: 'File History',
      icon: locationPathname === '/file-upload-history' ? <img src={ShipmentInvoiceActive} /> : <img src={ShipmentInvoice} />,
      path: '/file-upload-history',
      permission: ['fileHistory']
    },
    {
      label: 'Settings',
      icon: ['/account', '/users'].includes(locationPathname) || (openSubMenu === 'Settings') ? <img src={SettingsActive} /> : <img src={Settings} />,
      permission: ['settings'],
      subMenu: [
        {
          label: 'Account',
          path: '/account',
          permission: ['settings']
        },
        {
          label: 'Employee',
          path: '/employees',
          permission: ['settings']
        },
        {
          label: 'Billing',
          path: '/billing',
          permission: ['settings']
        }
      ]
    }

  ];

  const filteredUserMenu = userMenu.map((item) => {
    if (item.label === 'Settings') {
      return {
        ...item,
        subMenu: user?.id === 1 || user?.is_employee_of
          ? item.subMenu.filter(sub => sub.label !== 'Billing')
          : item.subMenu
      };
    }
    return item;
  });

  const filterSellerPlusWarehouseMenu = sellerPlusWarehouseMenu.map((item) => {
    if (item.label === 'Settings') {
      return {
        ...item,
        subMenu: user?.is_employee_of
          ? item.subMenu.filter(sub => sub.label !== 'Billing')
          : item.subMenu
      };
    }
    return item;
  });

  // Filter menu items based on user role and permissions
  const getFilteredMenu = (menu) => {
    return menu.filter(item => {
      // Always show menu items for admin (id: 1)
      if (user?.id === 1) return true;
      
      // For employees, only show specific menu items
      // if (user?.is_employee_of) {
      //   const employeeAllowedItems = [
      //     'Inventory',
      //     'Purchasing',
      //     'Logistics',
      //     'File History',
      //     'Settings'
      //   ];
      //   return employeeAllowedItems.includes(item.label);
      // }
      
      // For clients, filter out Billing if not subscribed
      if (user?.role?.id === 2 || user?.role?.id === 5) {
        if (item.label === 'Billing' && !isSubscribed) {
          return false;
        }
        return true;
      }
      
      return true;
    });
  };

  // Get the base menu based on user role
  let menuData;
  if (user?.role?.name === 'seller+warehouse') {
    menuData = getFilteredMenu(filterSellerPlusWarehouseMenu);
  } else if (user?.role?.name === 'Warehouse') {
    menuData = getFilteredMenu(warehouseMenu);
  } else {
    menuData = getFilteredMenu(filteredUserMenu);
  }

  const permissionBasedSidebarFilter = menuData
    .map(item => {
      // If user is not an employee or item has no permissions, show it
      if (!user?.is_employee_of || (!item.permission && !item.subMenu?.some(sub => sub.permission))) {
        return item;
      }

      const getPermissionKey = (value) => {
        const key = Object.keys(PERMISSION_MAP).find(
          (key) => PERMISSION_MAP[key] === value
        );
        return key ? parseInt(key, 10) : null;
      };

      const hasPermission = (permissionName) => {
        const permissionKey = getPermissionKey(permissionName);
        return user?.permissions?.includes(permissionKey);
      };

      if (item.subMenu) {
        const filteredSubMenu = item.subMenu.filter(subItem => {
          return !subItem.permission || subItem.permission.some(perm => hasPermission(perm));
        });
        if (filteredSubMenu.length > 0 || !item.permission) {
          return { ...item, subMenu: filteredSubMenu };
        }
        return null;
      }

      // For items without submenus, check their permission if they have any
      if (item.permission) {
        const allowed = item.permission.some(perm => hasPermission(perm));
        return allowed ? item : null;
      }

      // If no permission is specified, show the item
      return null;
    })
    .filter(Boolean);

  const isSubscribed =
    currentActiveSubscription?.status === 'active';

  const toggleSubMenu = (label) => {
    setOpenSubMenu(prevState => (prevState === label ? null : label));
  };

  const handleMenuClick = (path) => {
    navigate(path);
    handleSetTab(path);
  };

  return (
    <SidebarContainer>
      <ProSidebar collapsed={collapsed}>
        <Menu iconShape="circle">
          {permissionBasedSidebarFilter.map((menu, index) => {
            const isBilling = menu.path === '/billing' || menu.label === 'Billing';
            const isEmployee = user?.is_employee_of;
            const isDisabled = user?.id === 1 ? false : (user?.role?.id === 2 || user?.role?.id === 5) && !isSubscribed && !isBilling && !isEmployee;
            return (
            menu.subMenu ? (
              <SubMenu
                key={index}
                title={menu.label}
                icon={menu.icon}
                open={openSubMenu === menu.label}
                  onClick={() => {
                    if (!isDisabled) toggleSubMenu(menu.label);
                  }}
                className={`${selectedTab.parent === menu.label ? 'active' : ''}`}
              >
                {menu.subMenu.map((item, subIndex) => (
                  <MenuItem
                    key={`${index}-${subIndex}`}
                    className={`submenu-item ${item.path?.startsWith(location.pathname) ? 'active' : ''}`}
                    disabled={isDisabled}
                    onClick={() => {
                      if (!isDisabled) {
                        handleMenuClick(item.path);
                      }
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </SubMenu>
            ) : (
              <MenuItem
                key={index}
                icon={menu.icon}
                disabled={isDisabled}
                onClick={() => {
                  if (!isDisabled) {
                    handleMenuClick(menu.path);
                  }
                }}
                className={`${location.pathname === menu.path ? 'active' : ''}`}
              >
                {menu.label}
              </MenuItem>
            )
          );})}
        </Menu>
      </ProSidebar>
    </SidebarContainer>
  );
};

export default Sidebar;
